<template>
    <div class="register-page">
        <div class="page-content">
            <div class="top-nav">
                <div class="logo-section">
                    <span class="logo-text">{{ companyName }}</span>
                    <span class="separator">|</span>
                    <a href="/" class="home-link">返回首页</a>
                </div>
                <div class="page-title">{{ companyName }}电子招投标交易平台</div>
                <div class="login-link">
                    <a href="/login">如已注册,进入登录页面</a>
                </div>
            </div>

            <div class="register-form-container">
                <div class="register-panel">
                    <form class="register-form" @submit.prevent="submitForm">
                        <div class="form-header">
                            <!-- <div class="form-badge">欢迎注册</div> -->
                            <div>
                                <h3 class="form-title">注册信息填写</h3>
                                <p class="form-subtitle">请按提示完善基础信息，所有必填项都需要准确填写</p>
                            </div>
                        </div>

                        <div class="form-group">
                            <label class="form-label required">用户类型</label>
                            <div class="radio-group wide-field">
                                <label class="radio-item">
                                    <input type="radio" name="userType" value="1" v-model="formData.userType">
                                    <span class="radio-text">单位</span>
                                </label>
                                <label class="radio-item" :class="{ 'disabled': isBiddingAgent }">
                                    <input type="radio" name="userType" value="2" v-model="formData.userType" :disabled="isBiddingAgent">
                                    <span class="radio-text">自然人</span>
                                </label>
                            </div>
                        </div>

                        <!-- 单位名称 (仅单位类型显示) -->
                        <div class="form-group" v-if="formData.userType == 1">
                            <label class="form-label required">单位名称</label>
                            <input type="text" class="form-input" :class="{ 'input-error': checkErrors.company }" placeholder="请填写单位名称" v-model="formData.userName" @input="debounceCheckCompany">
                            <div v-if="checkErrors.company" class="field-error">{{ checkErrors.company }}</div>
                        </div>

                        <!-- 统一社会信用代码 (仅单位类型显示) -->
                        <div class="form-group" v-if="formData.userType == 1">
                            <label class="form-label required">统一社会信用代码</label>
                            <div class="code-row">
                                <select class="form-select-codeType" v-model="formData.codeType">
                                    <option value="1">统一社会信用代码</option>
                                    <option value="2">其他一证一照代码</option>
                                </select>
                                <input type="text" class="form-input" :class="{ 'input-error': checkErrors.ucc }" placeholder="填写18位有效统一信用号"
                                    v-model="formData.usccCode" @input="debounceCheckUcc">
                            </div>
                            <div v-if="checkErrors.ucc" class="field-error">{{ checkErrors.ucc }}</div>
                        </div>

                        <!-- 注册角色 -->
                        <div class="form-group">
                            <label class="form-label required">注册角色</label>
                            <select class="form-select" v-model="formData.roleId">
                                <option value="">请选择注册角色</option>
                                <option v-for="role in userRoles" :key="role.id" :value="role.id">{{ role.roleName }}
                                </option>
                            </select>
                        </div>

                        <!-- 注册人姓名 (仅自然人类型显示) -->
                        <div class="form-group" v-if="formData.userType == 2">
                            <label class="form-label required">注册人姓名</label>
                            <input type="text" class="form-input" placeholder="谁注册写谁即可,不是必须填写法人"
                                v-model="formData.userName">
                        </div>

                        <!-- 身份证号 (仅自然人类型显示) -->
                        <div class="form-group" v-if="formData.userType == 2">
                            <label class="form-label required">身份证号</label>
                            <input type="text" class="form-input" :class="{ 'input-error': checkErrors.idCard }" placeholder="填写注册人身份证号" v-model="formData.idCardNo" @input="debounceCheckIdCard">
                            <div v-if="checkErrors.idCard" class="field-error">{{ checkErrors.idCard }}</div>
                        </div>

                        <!-- 登录名 -->
                        <div class="form-group">
                            <label class="form-label required">登录名</label>
                            <input type="text" class="form-input" placeholder="自行设置,后期登录账号用"
                                v-model="formData.loginName">
                        </div>

                        <!-- 登录密码 -->
                        <div class="form-group">
                            <label class="form-label required">登录密码</label>
                            <input type="password" class="form-input" placeholder="输入不少于6位数字和字母组合"
                                v-model="formData.loginPwd">
                        </div>

                        <!-- 确认密码 -->
                        <div class="form-group">
                            <label class="form-label required">确认密码</label>
                            <input type="password" class="form-input" placeholder="确认密码"
                                v-model="formData.confirmPassword">
                        </div>

                        <!-- 邮箱 -->
                        <div class="form-group">
                            <label class="form-label required">邮箱</label>
                            <input type="email" class="form-input" placeholder="填写注册人邮箱" v-model="formData.email">
                        </div>

                        <!-- 验证码 -->
                        <div class="form-group">
                            <label class="form-label required">验证码</label>
                            <div class="captcha-group">
                                <input type="text" class="form-input captcha-input" placeholder="请输入图片验证码"
                                    v-model="formData.captchaCode">
                                <div class="captcha-image" @click="refreshCaptcha">
                                    <div v-if="captchaLoading" class="captcha-loading">加载中...</div>
                                    <img :src="getCaptchaImageUrl()" alt="验证码" v-else-if="captchaData.img">
                                    <div v-else class="captcha-placeholder">点击获取验证码</div>
                                    <div class="captcha-line"></div>
                                </div>
                            </div>
                        </div>

                        <!-- 所在地区 -->
                        <div class="form-group">
                            <label class="form-label required">所在地区</label>
                            <el-cascader ref="regionCascader" v-model="formData.region" placeholder="请选择省市区"
                                :props="regionCascaderProps" @change="handleRegionChange" class="region-cascader" />
                        </div>

                        <!-- 所属行业 -->
                        <div class="form-group">
                            <label class="form-label required">所属行业</label>
                            <el-cascader ref="industryCascader" v-model="formData.industry" placeholder="请选择所属行业"
                                :props="industryCascaderProps" @change="handleIndustryChange" class="region-cascader" />
                        </div>

                        <!-- 手机号 -->
                        <div class="form-group">
                            <label class="form-label required">手机号</label>
                            <input type="text" class="form-input" placeholder="填写注册人手机号" v-model="formData.phone">
                        </div>

                        <!-- 手机验证码 -->
                        <div class="form-group">
                            <label class="form-label required">手机验证码</label>
                            <div class="sms-group">
                                <input type="text" class="form-input sms-input" placeholder="请输入手机验证码"
                                    v-model="formData.smsCode">
                                <button type="button" class="sms-btn" :disabled="smsCountdown > 0" @click="sendSmsCode">
                                    {{ smsCountdown > 0 ? smsCountdown + '秒后重新获取' : '获取手机验证码' }}
                                </button>
                            </div>
                        </div>

                        <!-- 服务条款 -->
                        <div class="terms-group">
                            <label class="checkbox-item">
                                <input type="checkbox" v-model="formData.agreeTerms">
                                <span class="checkbox-text">我已接受并同意网站<span class="terms-link"
                                        @click="agreeTermsClcik">《用户服务条款》</span></span>
                            </label>
                        </div>

                        <div class="submit-group">
                            <button type="submit" class="submit-btn">立即注册</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getUserRoles, getCaptcha, register, getSmsCode,checkCompany ,checkIdCard,checkUcc} from '@/api/user/api'
import RegionUtils from '@/utils/regionUtils'

// // 检查单位名称是否存在
// export const checkCompany = (data) => {
//   return request.post('/api/user/check/company', data)
// }
// // 检检查统一社会验证码名称是否存在
// export const checkIdCard = (data) => {
//   return request.post('/api/user/check/id', data)
// }
// // 检查统一社会验证码名称是否存在
// export const checkUcc = (data) => {
//   return request.post('/api/user/check/ucc', data)
// }
export default {
    name: 'Register',
    data() {
        return {
            // 表单数据
            formData: {
                userType: 1, // 1:单位 2:自然人
                userName: '', // 用户名称
                usccCode: '', // 统一社会信用代码
                codeType: 1, // 1:统一社会信用代码 2:其他
                idCardNo: '', // 身份证号
                loginName: '', // 登录名
                loginPwd: '', // 登录密码
                email: '', // 邮箱
                phone: '', // 手机号
                roleId: '', // 角色ID
                captchaCode: '', // 图形验证码
                captchaCodeUuId: '', // 图形验证码UUID
                smsCode: '', // 短信验证码
                smsCodeUuId: '', // 短信验证码UUID
                agreeTerms: false,
                // 地区相关字段
                region: [], // 地区选择数组
                province: '', // 省名称
                provinceCode: '', // 省编码
                city: '', // 市名称
                cityCode: '', // 市编码
                county: '', // 县名称
                countyCode: '', // 县编码
                // 行业相关字段
                industry: [], // 行业选择数组
                industryLevel1: '', // 一级行业名称
                industryLevel1Code: '', // 一级行业编码
                industryLevel2: '', // 二级行业名称
                industryLevel2Code: '', // 二级行业编码
                industryLevel3: '', // 三级行业名称
                industryLevel3Code: '' // 三级行业编码
            },
            smsCountdown: 0,
            userRoles: [],// 所有注册角色
            captchaData: {},// 图形验证码数据
            captchaLoading: false,// 验证码加载状态
            // 防抖校验相关
            checkErrors: {
                company: '',
                idCard: '',
                ucc: ''
            },
            checkTimers: {
                company: null,
                idCard: null,
                ucc: null
            }
        }
    },
    computed: {
        // 公司名称
        companyName() {
            return this.$channelMaterial.getCompanyName()
        },
        // 地区级联选择器配置
        regionCascaderProps() {
            return RegionUtils.getCascaderProps()
        },
        // 行业级联选择器配置
        industryCascaderProps() {
            return RegionUtils.getCascaderProps('COMPANY_INDUSTRY_CODE')
        },
        channelCode() {
            return this.$channelMaterial.getChannelCode()
        },
        // 判断当前角色是否为招标代理
        isBiddingAgent() {
            if (!this.formData.roleId || !this.userRoles.length) return false
            const role = this.userRoles.find(r => r.id === this.formData.roleId)
            return role && (role.roleName === '招标代理' || role.roleName?.includes('代理'))
        }
    },
    watch: {
        // 当选择招标代理时，强制切换为单位类型
        'formData.roleId'(newVal) {
            if (newVal && this.isBiddingAgent && this.formData.userType === '2') {
                this.formData.userType = '1'
                this.$message.info('招标代理必须选择单位类型')
            }
        }
    },
    beforeDestroy() {
        // 清除防抖定时器
        Object.values(this.checkTimers).forEach(timer => {
            if (timer) clearTimeout(timer)
        })
    },
    mounted() {
        this.getUserRoles()
        this.getCaptcha()
        // 初始化表单地区字段
        RegionUtils.initRegionFields(this.formData)
        // 初始化表单行业字段
        RegionUtils.initRegionFields(this.formData, {
            provinceField: 'industryLevel1',
            provinceCodeField: 'industryLevel1Code',
            cityField: 'industryLevel2',
            cityCodeField: 'industryLevel2Code',
            countyField: 'industryLevel3',
            countyCodeField: 'industryLevel3Code',
            regionField: 'industry'
        })
    },
    methods: {
        // 防抖检查单位名称
        debounceCheckCompany() {
            this.formData.userName = this.formData.userName?.trim() || ''
            this.checkErrors.company = ''
            if (this.checkTimers.company) clearTimeout(this.checkTimers.company)
            if (!this.formData.userName) return
            this.checkTimers.company = setTimeout(() => {
                checkCompany({ keyword: this.formData.userName }).then(res => {
                    if (res.code === 200) {
                        this.checkErrors.company = ''
                    } else {
                        this.checkErrors.company = res.msg || '该单位名称已存在，不可注册'
                    }
                }).catch(() => {})
            }, 500)
        },
        // 防抖检查身份证号
        debounceCheckIdCard() {
            this.formData.idCardNo = this.formData.idCardNo?.trim() || ''
            this.checkErrors.idCard = ''
            if (this.checkTimers.idCard) clearTimeout(this.checkTimers.idCard)
            if (!this.formData.idCardNo) return
            this.checkTimers.idCard = setTimeout(() => {
                checkIdCard({ keyword: this.formData.idCardNo }).then(res => {
                    if (res.code === 200) {
                        this.checkErrors.idCard = ''
                    } else {
                        this.checkErrors.idCard = res.msg || '该身份证号已存在，不可注册'
                    }
                }).catch(() => {})
            }, 500)
        },
        // 防抖检查统一社会信用代码
        debounceCheckUcc() {
            this.formData.usccCode = this.formData.usccCode?.trim() || ''
            this.checkErrors.ucc = ''
            if (this.checkTimers.ucc) clearTimeout(this.checkTimers.ucc)
            if (!this.formData.usccCode) return
            this.checkTimers.ucc = setTimeout(() => {
                checkUcc({ keyword: this.formData.usccCode }).then(res => {
                    if (res.code === 200) {
                        this.checkErrors.ucc = ''
                    } else {
                        this.checkErrors.ucc = res.msg || '该统一社会信用代码已存在，不可注册'
                    }
                }).catch(() => {})
            }, 500)
        },
        //发送验证码
        sendSmsCode() {
            this.formData.phone = this.formData.phone?.trim() || ''
            if (!this.formData.phone) {
                this.$message.error('请填写手机号')
                return
            }
            let data = {
                phone: this.formData.phone,
                uuid: this.formData.captchaCodeUuId,
                captcha: this.formData.captchaCode,
                type: 'register'
            }
            getSmsCode(data).then(res => {
                if (res.code === 0) {
                    this.$message.success('发送成功')
                    this.smsCountdown = 60
                    let timer = setInterval(() => {
                        this.smsCountdown--
                        if (this.smsCountdown <= 0) {
                            clearInterval(timer)
                        }
                    }, 1000)
                } else {
                    this.$message.error(res.msg || '发送失败')
                }

            })

        },
        /**
         * 地区选择变化处理
         */
        async handleRegionChange(value) {
            await RegionUtils.handleRegionChange(
                value,
                this.$refs.regionCascader,
                this.formData,
                { enableDebug: false },
                this,
                'REGION_CODE'
            )
        },

        /**
         * 行业选择变化处理
         */
        async handleIndustryChange(value) {
            await RegionUtils.handleRegionChange(
                value,
                this.$refs.industryCascader,
                this.formData,
                {
                    provinceField: 'industryLevel1',
                    provinceCodeField: 'industryLevel1Code',
                    cityField: 'industryLevel2',
                    cityCodeField: 'industryLevel2Code',
                    countyField: 'industryLevel3',
                    countyCodeField: 'industryLevel3Code',
                    regionField: 'industry',
                    enableDebug: false
                },
                this,
                'COMPANY_INDUSTRY_CODE'
            )
        },

        /**
         * 提交注册表单
         */
        submitForm() {
            // 表单验证
            if (!this.validateForm()) {
                return
            }
            // 准备提交数据
            const submitData = {
                channelCode: this.channelCode,
                userType: parseInt(this.formData.userType),
                userName: this.formData.userName,
                usccCode: this.formData.usccCode,
                codeType: parseInt(this.formData.codeType),
                idCardNo: this.formData.idCardNo,
                loginName: this.formData.loginName,
                loginPwd: this.formData.loginPwd,
                email: this.formData.email,
                phone: this.formData.phone,
                roleId: parseInt(this.formData.roleId),
                captchaCode: this.formData.captchaCode,
                captchaCodeUuId: this.formData.captchaCodeUuId,
                smsCode: this.formData.smsCode,
                smsCodeUuId: this.formData.smsCodeUuId,
                // 地区信息
                provinceName: this.formData.province,
                provinceCode: this.formData.provinceCode,
                cityName: this.formData.city,
                cityCode: this.formData.cityCode,
                areaName: this.formData.county,
                areaCode: this.formData.countyCode,
                // 行业信息
                industryCode: this.formData.industryLevel3Code,
                industryName: this.formData.industryLevel3,
            }
            // 调用注册接口
            register(submitData).then(res => {
                if (res.code === 200) {
                    this.$message.success('注册成功！')
                    setTimeout(() => {
                        this.$router.push('/login')
                    }, 1000)
                } else {
                    this.$message.error(res.msg || '注册失败')
                }
            }).catch(error => {
                this.$message.error('注册失败，请重试')
                console.error('注册失败:', error)
            })
        },

        /**
         *  注册协议
         */
        agreeTermsClcik() {
            // 打开新窗口
            window.open('https://www.vbidding.com/contract.html')
        },
        /**
         * 表单验证
         */
        validateForm() {
            // 自动去除所有输入字段的首尾空格
            this.formData.userName = this.formData.userName?.trim() || ''
            this.formData.usccCode = this.formData.usccCode?.trim() || ''
            this.formData.loginName = this.formData.loginName?.trim() || ''
            this.formData.email = this.formData.email?.trim() || ''
            this.formData.phone = this.formData.phone?.trim() || ''
            this.formData.captchaCode = this.formData.captchaCode?.trim() || ''

            // 验证用户类型
            if (!this.formData.userType) {
                this.$message.error('请选择用户类型')
                return false
            }

            // 验证用户名称
            if (!this.formData.userName) {
                this.$message.error('请填写用户名称')
                return false
            }

            // 单位类型验证
            if (this.formData.userType == 1) {
                if (!this.formData.usccCode) {
                    this.$message.error('请填写统一社会信用代码')
                    return false
                }
                if (this.checkErrors.company) {
                    this.$message.error(this.checkErrors.company)
                    return false
                }
                if (this.checkErrors.ucc) {
                    this.$message.error(this.checkErrors.ucc)
                    return false
                }
            }

            // 自然人类型验证
            if (this.formData.userType == 2) {
                if (!this.formData.idCardNo) {
                    this.$message.error('请填写身份证号')
                    return false
                }
                if (this.checkErrors.idCard) {
                    this.$message.error(this.checkErrors.idCard)
                    return false
                }
            }

            // 验证角色
            if (!this.formData.roleId) {
                this.$message.error('请选择注册角色')
                return false
            }

            // 验证登录名
            if (!this.formData.loginName) {
                this.$message.error('请填写登录名')
                return false
            }

            // 验证密码
            if (!this.formData.loginPwd) {
                this.$message.error('请填写登录密码')
                return false
            }

            if (this.formData.loginPwd.length < 6) {
                this.$message.error('密码长度不能少于6位')
                return false
            }

            // 验证确认密码
            if (this.formData.loginPwd !== this.formData.confirmPassword) {
                this.$message.error('两次输入的密码不一致')
                return false
            }

            // 验证邮箱
            if (!this.formData.email) {
                this.$message.error('请填写邮箱')
                return false
            }

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if (!emailRegex.test(this.formData.email)) {
                this.$message.error('请填写正确的邮箱格式')
                return false
            }

            // 验证地区选择
            if (!this.formData.region || this.formData.region.length === 0) {
                this.$message.error('请选择所在地区')
                return false
            }

            // 验证行业选择
            if (!this.formData.industry || this.formData.industry.length === 0) {
                this.$message.error('请选择所属行业')
                return false
            }

            // 验证手机号
            if (!this.formData.phone) {
                this.$message.error('请填写手机号')
                return false
            }

            const phoneRegex = /^1[3-9]\d{9}$/
            if (!phoneRegex.test(this.formData.phone)) {
                this.$message.error('请填写正确的手机号格式')
                return false
            }

            // 验证图形验证码
            if (!this.formData.captchaCode) {
                this.$message.error('请填写图形验证码')
                return false
            }

            // 验证短信验证码
            if (!this.formData.smsCode) {
                this.$message.error('请填写短信验证码')
                return false
            }

            // 验证协议
            if (!this.formData.agreeTerms) {
                this.$message.error('请同意用户协议')
                return false
            }

            return true
        },
        /**
         * 获取所有注册角色
         */
        getUserRoles() {
            getUserRoles().then(res => {
                if (res.code === 200) {
                    this.userRoles = res.data
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        /**
         * 获取图形验证码
         */
        getCaptcha() {
            this.captchaLoading = true
            getCaptcha().then(res => {
                if (res.code === 0) {
                    this.captchaData = res.data
                    this.formData.captchaCodeUuId = res.data.uuid // 存储验证码UUID
                } else {
                    this.$message.error(res.msg)
                }
            }).catch(error => {
                this.$message.error('获取验证码失败')
            }).finally(() => {
                this.captchaLoading = false
            })
        },
        /**
         * 获取验证码图片URL
         */
        getCaptchaImageUrl() {
            if (this.captchaData.img) {
                return `data:image/jpeg;base64,${this.captchaData.img}`
            }
            return ''
        },
        /**
         * 刷新验证码
         */
        refreshCaptcha() {
            this.getCaptcha()
        }
    }
}
</script>

<style lang="less" scoped>
.register-page {
    position: relative;
    width: 100%;
    min-height: 100vh;
    background: url('/src/assets/image/new_slices/lgin_bg@2x.jpg') center center / cover no-repeat fixed;

}

.page-content {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    padding: 0 24px;
    max-width: 1280px;
    margin: 0 auto;
    position: relative;
}


.top-nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    padding: 20px 0 12px;
    color: #334155;
}

.logo-section {
    display: flex;
    align-items: center;
    gap: 8px;
    color: white;

    .logo-text {
        font-size: 15px;
        font-weight: 600;
    }

    .separator {
        color: white;
    }

    .home-link {
        color: white;
        text-decoration: none;
        font-size: 14px;
        font-weight: 500;

    }
}

.page-title {
    font-size: 20px;
    font-weight: 600;
    text-align: center;
    flex: 1;
    color: white;
}

.login-link {
    a {
        color: white;
        text-decoration: none;
        font-size: 15px;

    }
}

.register-form-container {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 12px 0 40px;
}

.register-panel {
    width: min(820px, 100%);
    background: rgba(255, 255, 255, 0.85);
    border: 1px solid rgba(255, 255, 255, 0.6);
    border-radius: 24px;
    box-shadow:
        0 20px 50px rgba(15, 23, 42, 0.12),
        0 4px 12px rgba(0, 0, 0, 0.05);
    backdrop-filter: blur(12px);
    overflow: hidden;
    position: relative;
    z-index: 1;
}

.register-form {
    padding: 32px 40px 36px;
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.form-header {
    margin-bottom: 24px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.form-badge {
    align-self: flex-start;
    padding: 6px 14px;
    border-radius: 999px;
    background: linear-gradient(135deg, #3b82f6, #06b6d4);
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);
}

.form-title {
    margin: 0;
    font-size: 26px;
    color: #0f172a;
    font-weight: 700;
}

.form-subtitle {
    margin: 6px 0 0;
    font-size: 13px;
    color: #64748b;
}

.form-group {
    margin-bottom: 16px;
    display: flex;
    align-items: flex-start;
}

.form-label {
    display: block;
    margin-bottom: 0;
    margin-right: 18px;
    font-size: 14px;
    color: #334155;
    font-weight: 600;
    min-width: 118px;
    line-height: 44px;
    text-align: right;

    &.required::before {
        content: '*';
        color: #F56C6C;
        margin-right: 4px;
    }
}

.radio-group {
    display: flex;
    gap: 14px;
}

.wide-field {
    width: 100%;
}

.radio-item {
    display: flex;
    align-items: center;
    cursor: pointer;
    min-height: 44px;
    padding: 0 18px;
    border: 1px solid #dbe3ef;
    border-radius: 12px;
    background: #fff;
    transition: all 0.2s ease;

    &:hover {
        border-color: #3b82f6;
        // box-shadow: 0 8px 18px rgba(139, 92, 246, 0.08);
    }

    // 禁用状态样式
    &.disabled {
        cursor: not-allowed;
        background: #f5f5f5;
        border-color: #e0e0e0;
        opacity: 0.6;

        &:hover {
            border-color: #e0e0e0;
        }

        .radio-text {
            color: #999;
        }
    }

    input[type="radio"] {
        margin-right: 8px;
        width: 16px;
        height: 16px;
        accent-color: #3b82f6;

        &:disabled {
            cursor: not-allowed;
        }
    }

    .radio-text {
        font-size: 14px;
        color: #333;
    }
}

.form-input {
    width: 100%;
    height: 44px;
    padding: 0 14px;
    border: 1px solid #d1d5db;
    border-radius: 10px;
    font-size: 14px;
    color: #334155;
    background: rgba(255, 255, 255, 0.9);
    transition: all 0.2s ease;

    &::placeholder {
        color: #9ca3af;
    }

    &:focus {
        outline: none;
        border-color: #3b82f6;
    }
}

.form-select {
    width: 100%;
    height: 44px;
    padding: 0 14px;
    border: 1px solid #d1d5db;
    border-radius: 10px;
    font-size: 14px;
    color: #334155;
    background: rgba(255, 255, 255, 0.9);
    transition: all 0.2s ease;

    &:focus {
        outline: none;
        border-color: #3b82f6;
    }
}

.form-select-codeType {
    width: 160px;
    margin-right: 10px;
    height: 44px;
    padding: 0 12px;
    border: 1px solid #d1d5db;
    border-radius: 10px;
    font-size: 14px;
    color: #334155;
    background: rgba(255, 255, 255, 0.9);
    transition: all 0.2s ease;

    &:focus {
        outline: none;
        border-color: #3b82f6;
    }
}

.code-row {
    display: flex;
    align-items: center;
    width: 100%;
}

.input-with-icon {
    position: relative;
    width: 100%;

    .form-input {
        width: 100%;
    }

    .info-icon {
        position: absolute;
        right: 12px;
        top: 50%;
        transform: translateY(-50%);
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: #409EFF;
        color: white;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-style: normal;
    }
}

.captcha-group {
    display: flex;
    gap: 12px;
    align-items: center;
    width: 100%;
}

.captcha-input {
    flex: 1;
}

.captcha-image {
    position: relative;
    width: 100px;
    height: 44px;
    background: #f8fafc;
    border: 1px solid #dbe3ef;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        border-color: #3b82f6;
        box-shadow: 0 8px 18px rgba(59, 130, 246, 0.08);
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .captcha-loading,
    .captcha-placeholder {
        font-size: 12px;
        color: #999;
        text-align: center;
        line-height: 40px;
    }

    .captcha-loading {
        color: #409EFF;
    }
}


.sms-group {
    display: flex;
    gap: 12px;
    align-items: center;
    width: 100%;
}

.sms-input {
    flex: 1;
}

.sms-btn {
    height: 44px;
    padding: 0 18px;
    background: linear-gradient(135deg, #3b82f6, #06b6d4);
    color: white;
    border: none;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;
    transition: all 0.2s ease;

    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 12px 24px rgba(59, 130, 246, 0.25);
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.65;
        transform: none;
        box-shadow: none;
    }
}

.sms-icon {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #F56C6C;
    color: white;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-style: normal;
    font-weight: bold;
}

.terms-group {
    margin: 12px 0 2px;
    padding-left: 136px;
}

.checkbox-item {
    display: flex;
    align-items: center;
    cursor: pointer;

    input[type="checkbox"] {
        margin-right: 8px;
        width: 16px;
        height: 16px;
        accent-color: #3b82f6;
    }

    .checkbox-text {
        font-size: 14px;
        color: #333;
    }
}

.submit-group {
    margin-top: 14px;
    text-align: center;
}

.submit-btn {
    width: 180px;
    height: 48px;
    background: linear-gradient(135deg, #3b82f6, #06b6d4);
    color: white;
    border: none;
    border-radius: 14px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.25s ease;
    box-shadow: 0 8px 20px rgba(59, 130, 246, 0.35);

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 12px 28px rgba(59, 130, 246, 0.45);
    }
}

.region-cascader {
    width: 100%;
}

// @media (max-width: 992px) {
//     .top-nav {
//         flex-direction: column;
//         align-items: flex-start;
//     }

//     .page-title {
//         text-align: left;
//     }
// }

// @media (max-width: 768px) {
//     .page-content {
//         padding: 0 14px;
//     }

//     .top-nav {
//         padding-top: 16px;
//     }

//     .register-form {
//         padding: 24px 18px 28px;
//     }

//     .register-panel {
//         width: 100%;
//         border-radius: 18px;
//     }

//     .form-group {
//         flex-direction: column;
//         align-items: stretch;
//     }

//     .form-label {
//         min-width: 0;
//         margin-right: 0;
//         margin-bottom: 8px;
//         text-align: left;
//         line-height: 1.5;
//     }

//     .code-row,
//     .captcha-group,
//     .sms-group {
//         flex-direction: column;
//         align-items: stretch;
//     }

//     .form-select-codeType,
//     .captcha-image,
//     .sms-btn,
//     .submit-btn {
//         width: 100%;
//     }

//     .terms-group,
//     .submit-group {
//         padding-left: 0;
//     }
// }

.terms-link {
    color: #8B5CF6;
}

.field-error {
    color: #f56c6c;
    font-size: 12px;
    margin-top: 4px;
    line-height: 1.4;
}

.input-error {
    border-color: #f56c6c !important;
}
</style>